import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';

import {
  showSettingsHelpDialog,
  closeSettings,
  saveSettingsAndCloseDialog,
  setMenuButtons,
  setPrevMenuButtons,
  familyUpdate,
  showQuickstartVideos,
} from 'actions/flinkPlayActions';
import { getFamilyMembersByFamily } from 'actions/familiesActions';

import { WhiteBox, ManagePrepaid, ManageSubscriptionPrepaid } from 'components/flink-play';
import SettingsButton from './SettingsButton/SettingsButton';

import SettingsFamilyForm from './SettingsFamilyForm/SettingsFamilyForm';
import SettingsBigButtons from './SettingsBigButtons/SettingsBigButtons.js';
import SettingsManagePurchase from './SettingsManagePurchase/SettingsManagePurchase';
import SelectCharacter from './SelectCharacter/SelectCharacter';
import SettingsSelectSolution from './SettingsSelectSolution/SettingsSelectSolution';
import SettingsSelectSolutionMulti from './SettingsSelectSolutionMulti/SettingsSelectSolutionMulti';
import SelectTheme from './SelectTheme/SelectTheme';
//import { audioURL } from 'config';
import { LOGOUT, HELP, PARENT_ADVICE } from 'consts/buttons';
import classes from './Settings.module.scss';
import SupportPhone from 'components/common/SupportPhone';
import {
  checkTeam,
  shouldShowMyAccount,
} from 'utils';
import api from 'api';

const defaultSettings = {
  bySolution: {},
  autoAnimation: true,
  teamHelp: true,
  activityHelp: true,
};

const Content = Object.freeze({
  MAIN: 'MAIN',
  FAMILY: 'FAMILY',
  CHARACTERS: 'CHARACTERS',
  THEMES: 'THEMES',
  ACCOUNT: 'ACCOUNT',
  SOLUTION: 'SOLUTION',
});

const getNormalizedPurchaseEntries = (familyPrepaidTime) => {
  const purchases = Array.isArray(familyPrepaidTime?.purchases)
    ? familyPrepaidTime.purchases
    : [];

  const activeProducts = Array.isArray(familyPrepaidTime?.activeProducts)
    ? familyPrepaidTime.activeProducts
    : [];

  const activeProductIds = Array.isArray(familyPrepaidTime?.activeProductIds)
    ? familyPrepaidTime.activeProductIds
    : [];

  const normalizedActiveEntries = [
    ...activeProducts.map((item) => {
      const productId = item?.productId || item?._id || item;
      return productId ? { ...item, productId, __source: 'activeProducts' } : null;
    }),
    ...activeProductIds.map((productId) => (
      productId ? { productId, __source: 'activeProductIds' } : null
    )),
  ].filter(Boolean);

  const normalizedPurchaseEntries = purchases
    .map((item) => {
      const productId = item?.productId?._id || item?.productId || item?._id || item;
      return productId ? { ...item, productId, __source: item?.__source || 'purchases' } : null;
    })
    .filter(Boolean);

  const merged = [];
  const seen = new Set();

  [...normalizedActiveEntries, ...normalizedPurchaseEntries].forEach((item) => {
    const key = String(item?.productId || '');
    if (!key || seen.has(key)) return;
    seen.add(key);
    merged.push(item);
  });

  return merged;
};

export class Settings extends Component {
  state = {
    isVisible: false,
    content: Content.MAIN,
    settings: {},
    familyTeam: true,
    familyPrepaidTime: null,
    multiProduct: false,
    multiSolutionLists: [],
    multiSolutions: [],
  };

  componentDidMount() {
    const {
      saveSettingsAndCloseDialog,
      closeSettings,
      learner: { settings, _id: learnerId, type: learnerType },
      setMenuButtons,
      locale,
      product,
      isInitialSettings,
      location,
      team,
      family,
    } = this.props;

    const learnerIds = product.onePerson
      ? [learnerId]
      : [learnerId, ...((team || []).map((item) => item._id))];

    console.log('Settings componentDidMount import check:', {
      SettingsBigButtonsType: typeof SettingsBigButtons,
      SettingsBigButtonsValue: SettingsBigButtons,
    });
    console.log('Settings: ', { settings, _id: learnerId, type: learnerType });
    console.log('Settings learners: ', learnerIds);
    console.log('Settings componentDidMount familyPrepaidTime: ', this.state.familyPrepaidTime);

    const learnerWithoutSettings = Array.isArray(team)
      ? team.filter((item) => !item.settings)
      : [];
    console.log('Settings learnerWithoutSettings: ', learnerWithoutSettings);

    const familyTeam = checkTeam(team, family);
    if (familyTeam !== null) {
      this.setState({ familyTeam });
    }
    console.log('FlinkPlay familyTeam: ', this.state.familyTeam);

    setMenuButtons([
      LOGOUT,
      PARENT_ADVICE,
      { type: HELP, onClick: () => this.showSettingsHelp() },
    ]);

    const {
      solutions,
      defaultSolutionsForAdmins,
      defaultSolutionsForMembers,
    } = product;

    const changedSettings = settings ? { ...settings } : { ...defaultSettings };
    const querySolutionId = location.state && location.state.solution;

    const preferSolutionId =
      querySolutionId || changedSettings.selectedSolutionId;

    let selectedSolution =
      preferSolutionId &&
      _.find(solutions, {
        _id: preferSolutionId,
      });

    if (!selectedSolution) {
      const defaultSolutions =
        (learnerType === 'adult'
          ? defaultSolutionsForAdmins
          : defaultSolutionsForMembers) || {};

      changedSettings.selectedSolutionId =
        defaultSolutions[locale.code] || (solutions[0] && solutions[0]._id);

      selectedSolution = _.find(solutions, {
        _id: changedSettings.selectedSolutionId,
      });
    }

    if (!selectedSolution) {
      return alert('No solutions in the product');
    }

    if (isInitialSettings && settings) {
      if (querySolutionId) {
        return saveSettingsAndCloseDialog(learnerId, {
          ...settings,
          selectedSolutionId: selectedSolution._id,
          bySolution: {
            ...(settings.bySolution || {}),
            [selectedSolution._id]: (settings.bySolution &&
              settings.bySolution[selectedSolution._id]) || {
              theme: selectedSolution.defaultTheme,
              character: selectedSolution.defaultCharacter,
            },
          },
        });
      } else if (learnerWithoutSettings.length && settings) {
        return saveSettingsAndCloseDialog(learnerId, {
          ...settings,
          selectedSolutionId: selectedSolution._id,
          bySolution: {
            ...(settings.bySolution || {}),
            [selectedSolution._id]: (settings.bySolution &&
              settings.bySolution[selectedSolution._id]) || {
              theme: selectedSolution.defaultTheme,
              character: selectedSolution.defaultCharacter,
            },
          },
        }, true);
      } else {
        return closeSettings();
      }
    }

    if (isInitialSettings && !settings) {
      changedSettings.selectedSolutionId = selectedSolution._id;
      changedSettings.bySolution[selectedSolution._id] = {
        theme: selectedSolution.defaultTheme,
        character: selectedSolution.defaultCharacter,
      };

      saveSettingsAndCloseDialog(learnerId, changedSettings);
      return;
    }

    this.setState({
      isVisible: true,
      settings: changedSettings,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      settings: { selectedSolutionId },
      familyPrepaidTime,
    } = this.state;

    if (prevState.settings.selectedSolutionId !== selectedSolutionId) {
      this.onSelectedSolutionChanged();
    }

    if (prevState.familyPrepaidTime !== familyPrepaidTime) {
      this.setMultiProduct();
    }
  }

  getAvailableAdditionalProductIds = async () => {
    console.log('[Settings][getAvailableAdditionalProductIds] skipped in debug mode: Settings uses owned products only');
    return [];
  };

  debugResolveProductNames = async (productIds, sourceTag = 'unknown') => {
    const normalizedIds = [...new Set(
      (Array.isArray(productIds) ? productIds : [])
        .filter(Boolean)
        .map((x) => String(x)),
    )];

    if (!normalizedIds.length) {
      console.log('[Settings][debugResolveProductNames] skip: empty ids', { sourceTag });
      return [];
    }

    try {
      const rows = await Promise.all(
        normalizedIds.map(async (productId) => {
          try {
            const result = await api.products.getProductName(productId);
            return {
              productId,
              name: result?.name || result?.title || result?.productName || null,
              raw: result || null,
            };
          } catch (error) {
            return {
              productId,
              name: null,
              error: error?.message || String(error),
            };
          }
        }),
      );

      console.log('[Settings][debugResolveProductNames]', {
        sourceTag,
        rows,
      });

      return rows;
    } catch (error) {
      console.log('[Settings][debugResolveProductNames] failed', {
        sourceTag,
        message: error?.message || String(error),
      });
      return [];
    }
  };

  /*setMultiProduct = () => {
    const { familyPrepaidTime } = this.state;
    const purchaseEntries = getNormalizedPurchaseEntries(familyPrepaidTime);

    if (!purchaseEntries.length) {
      console.log('[Settings][setMultiProduct] skip: no purchases', familyPrepaidTime);
      return;
    }

    const productIds = [...new Set(
      purchaseEntries
        .map((x) => x?.productId?._id || x?.productId)
        .filter(Boolean)
        .map((x) => String(x)),
    )];

    const shouldMulti = productIds.length > 1;

    console.log('[Settings][setMultiProduct] productIds:', productIds, 'shouldMulti:', shouldMulti);

    if (!shouldMulti) {
      if (this.state.multiProduct) {
        this.setState({
          multiProduct: false,
          multiSolutions: [],
          multiSolutionLists: [],
        });
      }
      return;
    }

    if (!this.state.multiProduct) {
      this.setState({ multiProduct: true });
    }

    this.fetchSolutionsList(purchaseEntries);
  };*/


  setMultiProduct = async () => {
    const { familyPrepaidTime } = this.state;
    const purchaseEntries = getNormalizedPurchaseEntries(familyPrepaidTime);

    const ownedProductIds = [...new Set(
      purchaseEntries
        .map((x) => x?.productId?._id || x?.productId)
        .filter(Boolean)
        .map((x) => String(x)),
    )];

    const ownedEntriesDebug = purchaseEntries.map((entry) => ({
      productId: String(entry?.productId?._id || entry?.productId || ''),
      title: entry?.title || entry?.productTitle || entry?.name || null,
      billingInterval: entry?.billingInterval || entry?.prepaidConfig?.billingInterval || null,
      source: entry?.__source || null,
      sourceKeys: Object.keys(entry || {}).sort(),
    }));

    console.log('[Settings][setMultiProduct][owned-source]', {
      familyPrepaidTime: {
        purchaseProductType: familyPrepaidTime?.purchaseProductType || null,
        activeProductIds: familyPrepaidTime?.activeProductIds || null,
        activeProductsLength: Array.isArray(familyPrepaidTime?.activeProducts) ? familyPrepaidTime.activeProducts.length : 0,
        purchasesLength: Array.isArray(familyPrepaidTime?.purchases) ? familyPrepaidTime.purchases.length : 0,
      },
      ownedEntriesDebug,
      ownedProductIds,
    });

    await this.debugResolveProductNames(ownedProductIds, 'setMultiProduct:ownedProductIds');

    const productIdsForSolutions = ownedProductIds;
    const shouldMulti = productIdsForSolutions.length > 1;

    console.log('[Settings][setMultiProduct][final]', {
      productIdsForSolutions,
      shouldMulti,
    });

    if (!shouldMulti) {
      if (this.state.multiProduct) {
        this.setState({
          multiProduct: false,
          multiSolutions: [],
          multiSolutionLists: [],
        });
      }
      return;
    }

    if (!this.state.multiProduct) {
      this.setState({ multiProduct: true });
    }

    this.fetchSolutionsList(productIdsForSolutions);
  };

fetchSolutionsList = async (productIdsInput) => {
  const unwrapMultiProductSolutions = (resp) => {
    if (!resp) return [];
    if (Array.isArray(resp)) return resp;

    if (Array.isArray(resp.data)) return resp.data;
    if (Array.isArray(resp?.data?.data)) return resp.data.data;
    if (Array.isArray(resp.products)) return resp.products;
    if (Array.isArray(resp?.data?.products)) return resp.data.products;

    return [];
  };

  const productIds = [...new Set(
    (Array.isArray(productIdsInput) ? productIdsInput : [])
      .filter(Boolean)
      .map((x) => String(x)),
  )];

  const resp = await api.products.getMultiProductSolutions(productIds);
  const list = unwrapMultiProductSolutions(resp);

  console.log('[Settings][getMultiProductSolutions]', {
    productIds,
    respType: Array.isArray(resp) ? 'array' : typeof resp,
    listLen: list.length,
    products: list.map((item) => ({
      productId: String(item?._id || item?.productId || ''),
      name: item?.name || item?.title || item?.productName || null,
      solutionsCount: Array.isArray(item?.solutions) ? item.solutions.length : 0,
      solutionListsCount: Array.isArray(item?.solutionLists) ? item.solutionLists.length : 0,
      solutionNames: Array.isArray(item?.solutions)
        ? item.solutions.map((solution) => ({
            id: String(solution?._id || ''),
            locale: solution?.locale || null,
            displayName: solution?.displayName || solution?.name || null,
          }))
        : [],
    })),
  });

  if (list.length !== productIds.length) {
    console.log('[Settings][getMultiProductSolutions][missing-products]', {
      requestedProductIds: productIds,
      returnedProductIds: list.map((item) => String(item?._id || item?.productId || '')),
    });
  }

  const solutionsMerged = list
    .flatMap((p) => (Array.isArray(p?.solutions) ? p.solutions : []))
    .filter(Boolean)
    .filter((s, index, self) =>
      index === self.findIndex((x) => String(x?._id) === String(s?._id)),
    );

  const solutionListsMerged = list
    .flatMap((p) => (Array.isArray(p?.solutionLists) ? p.solutionLists : []))
    .filter(Boolean);

  if (!solutionsMerged.length) {
    console.warn('[Settings][multiProductSolutions] empty solutionsMerged -> fallback to single-product mode');
    this.setState({
      multiProduct: false,
      multiSolutionLists: [],
      multiSolutions: [],
    });
    return;
  }

  this.setState(
    {
      multiSolutionLists: solutionListsMerged,
      multiSolutions: solutionsMerged,
    },
    () => {
      this.setMultiProductSolutions();
    },
  );

  console.log('[Settings][multiProductArr]', {
    productIds,
    solutions: solutionsMerged.length,
    lists: solutionListsMerged.length,
  });
};

  /*fetchSolutionsList = async (purchases) => {
    const unwrapMultiProductSolutions = (resp) => {
      if (!resp) return [];
      if (Array.isArray(resp)) return resp;

      if (Array.isArray(resp.data)) return resp.data;
      if (Array.isArray(resp?.data?.data)) return resp.data.data;
      if (Array.isArray(resp.products)) return resp.products;
      if (Array.isArray(resp?.data?.products)) return resp.data.products;

      return [];
    };

    const productIds = [...new Set(
      (Array.isArray(purchases) ? purchases : [])
        .map((x) => x?.productId?._id || x?.productId)
        .filter(Boolean)
        .map((x) => String(x)),
    )];

    const resp = await api.products.getMultiProductSolutions(productIds);
    const list = unwrapMultiProductSolutions(resp);

    console.log('[Settings][getMultiProductSolutions]', {
      productIds,
      respType: Array.isArray(resp) ? 'array' : typeof resp,
      listLen: list.length,
    });

    const solutionsMerged = list
      .flatMap((p) => (Array.isArray(p?.solutions) ? p.solutions : []))
      .filter(Boolean)
      .filter((s, index, self) =>
        index === self.findIndex((x) => String(x?._id) === String(s?._id)),
      );

    const solutionListsMerged = list
      .flatMap((p) => (Array.isArray(p?.solutionLists) ? p.solutionLists : []))
      .filter(Boolean);

    if (!solutionsMerged.length) {
      console.warn('[Settings][multiProductSolutions] empty solutionsMerged -> fallback to single-product mode');
      this.setState({
        multiProduct: false,
        multiSolutionLists: [],
        multiSolutions: [],
      });
      return;
    }

    this.setState(
      {
        multiSolutionLists: solutionListsMerged,
        multiSolutions: solutionsMerged,
      },
      () => {
        this.setMultiProductSolutions();
      },
    );

    console.log('[Settings][multiProductArr]', {
      solutions: solutionsMerged.length,
      lists: solutionListsMerged.length,
    });
  };*/

  setMultiProductSolutions = () => {
    const {
      saveSettingsAndCloseDialog,
      closeSettings,
      learner: { settings, _id: learnerId },
      locale,
      isInitialSettings,
      location,
      team,
    } = this.props;

    const { multiSolutions } = this.state;

    const learnerWithoutSettings = Array.isArray(team)
      ? team.filter((item) => !item.settings)
      : [];

    const changedSettings = settings ? { ...settings } : { ...defaultSettings };
    const querySolutionId = location.state && location.state.solution;

    const preferSolutionId =
      querySolutionId || changedSettings.selectedSolutionId;

    let selectedSolution =
      preferSolutionId &&
      _.find(multiSolutions, {
        _id: preferSolutionId,
      });

    if (!selectedSolution) {
      const defaultSolutions = multiSolutions.filter((item) => item.locale === locale.code);

      changedSettings.selectedSolutionId =
        (defaultSolutions[0] && defaultSolutions[0]._id) ||
        (multiSolutions[0] && multiSolutions[0]._id);

      selectedSolution = _.find(multiSolutions, {
        _id: changedSettings.selectedSolutionId,
      });
    }

    if (!selectedSolution) {
      return alert('No solutions in the product');
    }

    if (isInitialSettings && settings) {
      if (querySolutionId) {
        return saveSettingsAndCloseDialog(learnerId, {
          ...settings,
          selectedSolutionId: selectedSolution._id,
          bySolution: {
            ...(settings.bySolution || {}),
            [selectedSolution._id]: (settings.bySolution &&
              settings.bySolution[selectedSolution._id]) || {
              theme: selectedSolution.defaultTheme,
              character: selectedSolution.defaultCharacter,
            },
          },
        });
      } else if (learnerWithoutSettings.length && settings) {
        return saveSettingsAndCloseDialog(learnerId, {
          ...settings,
          selectedSolutionId: selectedSolution._id,
          bySolution: {
            ...(settings.bySolution || {}),
            [selectedSolution._id]: (settings.bySolution &&
              settings.bySolution[selectedSolution._id]) || {
              theme: selectedSolution.defaultTheme,
              character: selectedSolution.defaultCharacter,
            },
          },
        }, true);
      } else {
        return closeSettings();
      }
    }

    if (isInitialSettings && !settings) {
      changedSettings.selectedSolutionId = selectedSolution._id;
      changedSettings.bySolution[selectedSolution._id] = {
        theme: selectedSolution.defaultTheme,
        character: selectedSolution.defaultCharacter,
      };

      saveSettingsAndCloseDialog(learnerId, changedSettings);
      return;
    }

    this.setState({
      isVisible: true,
      settings: changedSettings,
    });
  };

  componentWillUnmount() {
    const { isInitialSettings, setPrevMenuButtons } = this.props;
    setPrevMenuButtons();

    if (isInitialSettings) {
      const event = new CustomEvent('initialSettingsClosed');
      document.dispatchEvent(event);
    }
  }

  /*showSettingsHelp = (cb) => {
    const { learner, showHelp, locale, translate } = this.props;

    const { isAdmin } = learner;

    const audioHelp = `${audioURL}/Generic/SettingsHelp/${
      locale.name
    }/InitialHelp${isAdmin ? 'Admin' : 'Member'}.mp3`;

    showHelp({
      title: translate(196, 'Settings Help'),
      stringNumber: isAdmin ? 77 : 49,
      cb,
      audioHelp,
      customTranslate: translate,
    });
  };*/

  showSettingsHelp = (cb) => {
    const { learner, showHelp, translate } = this.props;

    const stringNumber = learner?.type === 'adult' ? 49 : 77;

    console.log('[Settings.showSettingsHelp]', {
      learnerType: learner?.type,
      learnerIsAdmin: learner?.isAdmin,
      stringNumber,
    });

    showHelp({
      title: translate(196, 'Settings Help'),
      stringNumber,
      cb,
      customTranslate: translate,
    });
  };

  openFamilyForm = async () => {
    const { getFamilyMembersByFamily, family } = this.props;

    const familyMembers = await getFamilyMembersByFamily(family._id);

    if (!familyMembers) return;

    const familyFormInitialValues = {
      ...family,
      familyMembers: familyMembers.sort((a) => (a.isAdmin ? -1 : 1)),
    };

    this.setState({ content: Content.FAMILY, familyFormInitialValues });
  };

  familyFormOnSuccess = (family) => {
    const { familyUpdate } = this.props;
    familyUpdate(family);
    this.closeFamilyForm();
  };

  closeFamilyForm = () => {
    this.setState({ content: Content.MAIN, familyFormInitialValues: null });
  };

  changeSettingsInCurrentSolution = (prop, value) => {
    const { settings } = this.state;
    const { selectedSolutionId, bySolution = {} } = settings;

    const currentSolutionSettings = bySolution[selectedSolutionId] || {};
    currentSolutionSettings[prop] = value;

    this.setState({
      settings: {
        ...settings,
        bySolution: {
          ...bySolution,
          [selectedSolutionId]: currentSolutionSettings,
        },
      },
    });
  };

  changeSettings = (prop, value) => {
    const { settings } = this.state;
    this.setState({ settings: { ...settings, [prop]: value } });
  };

  onSelectedSolutionChanged = () => {
    const { settings, multiProduct, multiSolutions } = this.state;
    const { selectedSolutionId, bySolution = {} } = settings;
    const { product } = this.props;

    const safeProductSolutions = Array.isArray(product?.solutions) ? product.solutions : [];
    const safeMultiSolutions = Array.isArray(multiSolutions) ? multiSolutions : [];
    const selectedSolutionSource = !multiProduct ? safeProductSolutions : safeMultiSolutions;

    const selectedSolution = _.find(selectedSolutionSource, {
      _id: selectedSolutionId,
    });

    if (!selectedSolution) {
      console.warn('[Settings][onSelectedSolutionChanged] selectedSolution not found', {
        selectedSolutionId,
        multiProduct,
        safeProductSolutionsLen: safeProductSolutions.length,
        safeMultiSolutionsLen: safeMultiSolutions.length,
      });
      return;
    }

    const bySolutionSettings =
      (bySolution[selectedSolutionId] && {
        ...bySolution[selectedSolutionId],
      }) ||
      {};

    const themesOptions = _.chain(selectedSolution.themes || [])
      .map((theme) => ({ value: theme._id, label: theme.name }))
      .sortBy('label')
      .value();

    if (bySolutionSettings.theme) {
      const theme = _.find(selectedSolution.themes, {
        _id: bySolutionSettings.theme,
      });

      if (!theme) {
        bySolutionSettings.theme = selectedSolution.defaultTheme;
      }
    } else if (bySolutionSettings.theme === undefined) {
      bySolutionSettings.theme = selectedSolution.defaultTheme;
    }

    const charactersOptions = _.chain(selectedSolution.characters || [])
      .map((character) => ({ value: character._id, label: character.name }))
      .sortBy('label')
      .value();

    if (bySolutionSettings.character) {
      const character = _.find(selectedSolution.characters, {
        _id: bySolutionSettings.character,
      });

      if (!character) {
        bySolutionSettings.character = selectedSolution.defaultCharacter;
      }
    } else if (bySolutionSettings.character === undefined) {
      bySolutionSettings.character = selectedSolution.defaultCharacter;
    }

    this.setState({
      themesOptions,
      charactersOptions,
      settings: {
        ...settings,
        bySolution: { ...bySolution, [selectedSolutionId]: bySolutionSettings },
      },
    });
  };

  saveSettings = () => {
    const { saveSettingsAndCloseDialog, learner } = this.props;
    const { settings } = this.state;

    saveSettingsAndCloseDialog(learner._id, settings);
  };

  openContent = (content) => this.setState({ content });
  closeContent = () => this.setState({ content: Content.MAIN });

  handleFamilyPrepaid = (value) => {
    console.log('[Settings][handleFamilyPrepaid]', {
      value,
      normalizedEntries: getNormalizedPurchaseEntries(value).map((entry) => ({
        productId: String(entry?.productId?._id || entry?.productId || ''),
        title: entry?.title || entry?.productTitle || entry?.name || null,
        source: entry?.__source || null,
        sourceKeys: Object.keys(entry || {}).sort(),
      })),
    });

    this.setState((prevState) => {
      const prevValue = prevState.familyPrepaidTime || {};
      const prevSignature = JSON.stringify({
        purchaseProductType: prevValue.purchaseProductType,
        fullyPaid: prevValue.fullyPaid,
        prepaidDaysRemaining: prevValue.prepaidDaysRemaining,
        activeProductCount: prevValue.activeProductCount,
        currentPeriodEndsAt: prevValue.currentPeriodEndsAt,
        purchasesLength: getNormalizedPurchaseEntries(prevValue).length,
      });

      const nextSignature = JSON.stringify({
        purchaseProductType: value?.purchaseProductType,
        fullyPaid: value?.fullyPaid,
        prepaidDaysRemaining: value?.prepaidDaysRemaining,
        activeProductCount: value?.activeProductCount,
        currentPeriodEndsAt: value?.currentPeriodEndsAt,
        purchasesLength: getNormalizedPurchaseEntries(value).length,
      });

      if (prevSignature === nextSignature) {
        return null;
      }

      return { familyPrepaidTime: value };
    });
  };

  render() {
    const {
      closeSettings,
      showQuickstartVideos,
      locale,
      translate,
      family,
      product,
      learner: { settings: currentSettings },
    } = this.props;

    const {
      content,
      isVisible,
      themesOptions,
      charactersOptions,
      settings,
      familyFormInitialValues,
      familyTeam,
      familyPrepaidTime,
      multiProduct,
      multiSolutionLists,
      multiSolutions,
    } = this.state;

    console.log('Settings familyPrepaidTime: ', familyPrepaidTime);

    const { selectedSolutionId, bySolution = {} } = settings;
    const selectedSolution = (Array.isArray(multiSolutions) ? multiSolutions : [])
      .filter((item) => item._id === selectedSolutionId);

    console.log('Settings [multiSolutions, selectedSolutionId, selectedSolution]: ',
      [multiSolutions, selectedSolutionId, selectedSolution]);

    console.log('[Settings][render][solutions]', {
      multiProduct,
      multiSolutions: (Array.isArray(multiSolutions) ? multiSolutions : []).map((solution) => ({
        id: String(solution?._id || ''),
        locale: solution?.locale || null,
        displayName: solution?.displayName || solution?.name || null,
      })),
      multiSolutionLists: (Array.isArray(multiSolutionLists) ? multiSolutionLists : []).map((list) => ({
        id: String(list?._id || ''),
        name: list?.name || null,
        locale: list?.locale || null,
        solutions: Array.isArray(list?.solutions)
          ? list.solutions.map((solutionId) => String(solutionId))
          : [],
      })),
    });

    const currentSolutionSettings =
      (bySolution && bySolution[selectedSolutionId]) || {};

    if (!isVisible) return null;

    const showCharactersButton =
      charactersOptions && !!charactersOptions.length;
    const showThemesButton = themesOptions && !!themesOptions.length;
    const showSolutionsButton =
      product.solutions && product.solutions.length > 1;

    /*const canShowMyAccount = shouldShowMyAccount({
      purchaseProductType: familyPrepaidTime?.purchaseProductType,
      fullyPaid: familyPrepaidTime?.fullyPaid,
      freeTrialWeeks: familyPrepaidTime?.freeTrialWeeks,
    });

    const shouldUseSubscriptionManageFlow =
      familyPrepaidTime?.purchaseProductType === 'subscription' ||
      Number(familyPrepaidTime?.freeTrialWeeks || 0) > 0;

    console.log('[Settings][ACCOUNT]', {
      purchaseProductType: familyPrepaidTime?.purchaseProductType,
      freeTrialWeeks: familyPrepaidTime?.freeTrialWeeks,
      fullyPaid: familyPrepaidTime?.fullyPaid,
      canShowMyAccount,
      shouldUseSubscriptionManageFlow,
    });*/

    const canShowMyAccount = shouldShowMyAccount({
  purchaseProductType: familyPrepaidTime?.purchaseProductType,
  fullyPaid: familyPrepaidTime?.fullyPaid,
  freeTrialWeeks: familyPrepaidTime?.freeTrialWeeks,
});

const normalizedPurchaseEntries = getNormalizedPurchaseEntries(familyPrepaidTime);

const hasLegacyHourlyShape =
  Number.isFinite(Number(familyPrepaidTime?.totalHours)) &&
  Number.isFinite(Number(familyPrepaidTime?.totalHoursPaid)) &&
  Number.isFinite(Number(familyPrepaidTime?.costPerHour));

const isSubscriptionLikePurchase =
  familyPrepaidTime?.purchaseProductType === 'subscription' ||
  familyPrepaidTime?.purchaseProductType === 'org_subscription';

const hasResolvedSubscriptionShape =
  isSubscriptionLikePurchase ||
  Number(familyPrepaidTime?.freeTrialWeeks || 0) > 0 ||
  Boolean(familyPrepaidTime?.billingInterval) ||
  Boolean(familyPrepaidTime?.subscriptionType) ||
  Boolean(familyPrepaidTime?.currentPeriodEndsAt) ||
  Boolean(familyPrepaidTime?.nextRenewalDate) ||
  Number(familyPrepaidTime?.nextPaymentAmount || 0) > 0 ||
  Boolean(familyPrepaidTime?.subscriptionId) ||
  Boolean(familyPrepaidTime?.automaticPayments) ||
  normalizedPurchaseEntries.length > 0;

const isUnresolvedPrepaidState =
  family.isPrepaidCustomer &&
  canShowMyAccount &&
  !hasResolvedSubscriptionShape &&
  !hasLegacyHourlyShape;

const shouldUseSubscriptionManageFlow =
  family.isPrepaidCustomer &&
  canShowMyAccount &&
  (isUnresolvedPrepaidState || hasResolvedSubscriptionShape);

console.log('[Settings][ACCOUNT]', {
  purchaseProductType: familyPrepaidTime?.purchaseProductType || null,
  freeTrialWeeks: familyPrepaidTime?.freeTrialWeeks ?? null,
  fullyPaid: familyPrepaidTime?.fullyPaid ?? null,
  billingInterval: familyPrepaidTime?.billingInterval || null,
  subscriptionType: familyPrepaidTime?.subscriptionType || null,
  currentPeriodEndsAt: familyPrepaidTime?.currentPeriodEndsAt || null,
  nextRenewalDate: familyPrepaidTime?.nextRenewalDate || null,
  nextPaymentAmount: familyPrepaidTime?.nextPaymentAmount ?? null,
  subscriptionId: familyPrepaidTime?.subscriptionId || null,
  automaticPayments: familyPrepaidTime?.automaticPayments ?? null,
  normalizedPurchasesLength: normalizedPurchaseEntries.length,
  hasLegacyHourlyShape,
  hasResolvedSubscriptionShape,
  isUnresolvedPrepaidState,
  canShowMyAccount,
  shouldUseSubscriptionManageFlow,
});

    return (
      <div className={classes.overlay}>
        <WhiteBox
          outerClass={classes.settingsOuter}
          innerClass={classes.settingsInner}
        >
          {content === Content.MAIN && (
            <>
              <SettingsBigButtons
                openAccount={() => this.openContent(Content.ACCOUNT)}
                showQuickstartVideos={showQuickstartVideos}
                currentLocaleCode={locale.code}
                currentLocaleName={locale.name}
                openFamilyForm={this.openFamilyForm}
                familyTeam={familyTeam}
                translate={translate}
                settings={settings}
                changeHandler={this.changeSettings}
                familyPrepaid={familyPrepaidTime}
                handleFamilyPrepaid={this.handleFamilyPrepaid}
                openCharacters={
                  showCharactersButton
                    ? () => this.openContent(Content.CHARACTERS)
                    : undefined
                }
                openThemes={
                  showThemesButton
                    ? () => this.openContent(Content.THEMES)
                    : undefined
                }
                openSolutions={
                  showSolutionsButton
                    ? () => this.openContent(Content.SOLUTION)
                    : undefined
                }
                multiSolutions={multiSolutions}
              />

              <div className={classes.bottom}>
                <SupportPhone className={classes.phone} />

                <div className={classes.settingsActions}>
                  {currentSettings && (
                    <SettingsButton onClick={closeSettings}>
                      {translate(52, 'Cancel')}
                    </SettingsButton>
                  )}
                  <SettingsButton
                    onClick={this.saveSettings}
                    disabled={
                      currentSettings &&
                      JSON.stringify(currentSettings) ===
                        JSON.stringify(settings)
                    }
                  >
                    {translate(298, 'Save')}
                  </SettingsButton>
                </div>
              </div>
            </>
          )}

          {content === Content.FAMILY && (
            <SettingsFamilyForm
              onSuccess={this.familyFormOnSuccess}
              closeHandler={this.closeFamilyForm}
              translate={translate}
              initialValues={familyFormInitialValues}
            />
          )}

          {content === Content.ACCOUNT && (
            <div className={classes.popup}>
              <div className={classes.popupViewport}>
                {family.isPrepaidCustomer ? (
                  shouldUseSubscriptionManageFlow
                    ? <ManageSubscriptionPrepaid translate={translate} />
                    : <ManagePrepaid translate={translate} />
                ) : (
                  <SettingsManagePurchase translate={translate} />
                )}
              </div>

              <div className={classes.popupActions}>
                <SettingsButton onClick={this.closeContent}>
                  {translate(58, 'Go Back')}
                </SettingsButton>
              </div>
            </div>
          )}

          {content === Content.CHARACTERS && (
            <>
              <SelectCharacter
                options={charactersOptions}
                value={currentSolutionSettings.character}
                onChange={(value) =>
                  this.changeSettingsInCurrentSolution('character', value)
                }
              />
              {this.renderCloseContentButton()}
            </>
          )}

          {content === Content.THEMES && (
            <>
              <SelectTheme
                options={themesOptions}
                value={currentSolutionSettings.theme}
                onChange={(value) =>
                  this.changeSettingsInCurrentSolution('theme', value)
                }
              />
              {this.renderCloseContentButton()}
            </>
          )}

          {content === Content.SOLUTION && (
            <>
              {!multiProduct ? (
                <SettingsSelectSolution
                  translate={translate}
                  solutionLists={product.solutionLists}
                  value={selectedSolutionId}
                  solutions={product.solutions}
                  onChange={(solutionId) =>
                    this.changeSettings('selectedSolutionId', solutionId)
                  }
                />
              ) : (
                <SettingsSelectSolutionMulti
                  translate={translate}
                  solutionLists={multiSolutionLists}
                  value={selectedSolutionId}
                  solutions={multiSolutions}
                  onChange={(solutionId) =>
                    this.changeSettings('selectedSolutionId', solutionId)
                  }
                />
              )}
              {this.renderCloseContentButton()}
            </>
          )}
        </WhiteBox>
      </div>
    );
  }

  renderCloseContentButton = () => {
    const { translate } = this.props;
    return (
      <div className={classes.bottom}>
        <SettingsButton onClick={this.closeContent}>
          {translate(58, 'Go Back')}
        </SettingsButton>
      </div>
    );
  };
}

Settings.propTypes = {
  isInitialSettings: PropTypes.bool,
  closeSettings: PropTypes.func.isRequired,
  familyUpdate: PropTypes.func.isRequired,
  getFamilyMembersByFamily: PropTypes.func.isRequired,
  saveSettingsAndCloseDialog: PropTypes.func.isRequired,
  showHelp: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
  learner: PropTypes.object.isRequired,
  team: PropTypes.array,
  setMenuButtons: PropTypes.func.isRequired,
  setPrevMenuButtons: PropTypes.func.isRequired,
};

const mapStateToProps = ({
  flinkPlay: {
    product,
    family,
    isInitialSettings,
    solutionTranslate,
    solutionLocale,
    learner,
    team,
  },
  status,
}) => ({
  product,
  family,
  team,
  learner,
  isInitialSettings,
  translate: solutionTranslate || status.translate,
  locale: solutionLocale || status.lang,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    showHelp: showSettingsHelpDialog,
    closeSettings,
    familyUpdate,
    saveSettingsAndCloseDialog,
    getFamilyMembersByFamily,
    setMenuButtons,
    setPrevMenuButtons,
    showQuickstartVideos,
  }),
)(Settings);